import React, {Component} from 'react';
import {observer} from 'mobx-react';
import monitorStore from '../../Monitor/request/model';
import {getMonitor} from '../../Monitor/request/dao';
import './index.styl';

const clzpre = 'dsh-monitor';

@observer
class Monitor extends Component{
    constructor(props) {
        super(props);
        this.defaultNumber = 4;
        this.state = {
            'currentDisplayData': []
        };
        this.currentlastindex = 0;
        this.intervalData = undefined;
    }

    componentDidMount() {
        getMonitor().then(
            data => {
                this.getcurrentData(true);
                this.intervalData = setInterval(this.getcurrentData, 1000 * 20);
            }
        );
    }

    componentWillUnmount() {
        clearInterval(this.intervalData);
    }

    getcurrentData = (forceflag = false) => {
        const {monitors} = this.props.monitorStore;
        let data = [];
        let newIndex = 0;
        if((!monitors || []).length) {
            return;
        }
        if((this.currentlastindex + this.defaultNumber - 1) < monitors.length - 1 ) {
            data = monitors.slice(this.currentlastindex, this.currentlastindex + this.defaultNumber);
            newIndex = this.currentlastindex + this.defaultNumber;
        } else {
            data = monitors.slice(this.currentlastindex);
            newIndex = 0;
        }
        if(newIndex !== this.currentlastindex || forceflag) {
            this.currentlastindex = newIndex;
            this.setState({
                'currentDisplayData': data
            });
        }
    };

    generateCameraArea = () => {
        const data = this.state.currentDisplayData || [];
        const arr = [];
        for(let i = 0; i < this.defaultNumber; i++) {
            const temp = data[i] || {};
            const mediaData = temp.mediaData || {};
            if(temp && mediaData && mediaData.url && mediaData.accessToken) {
                arr.push(
                    <iframe
                        className={'single-frame'}
                        title={`frame${i}`}
                        width={'400px'}
                        height={'300px'}
                        key={`frame${i}`}
                        allowFullScreen
                        src={`${mediaData.url}&autoplay=1&accessToken=${mediaData.accessToken}`}
                    ></iframe>
                );
            } else {
                arr.push(
                    <div className={'single-frame empty-div'} key={`frame${i}`}>
                        暂无视频
                    </div>
                );
            }
        }
        return arr;
    };

    render(){
        return <div className={`${clzpre} dsh-box`}>
            <h3>监控模块</h3>
            <div>
                {this.generateCameraArea()}
            </div>
        </div>;
    }
}

export default (props) => <Monitor {...props} monitorStore={monitorStore}/>;
